export default [
  {
    path: '/shopCart',
    name: 'shopCart',
    meta: {
      hideTab:true
    },
    component: () => import('@/views/shopCart/index.vue')
  }
]